<ac-card>
  <ac-card-header [hideBack]="true" (close)="dialogRef.close()">
  </ac-card-header>

  <ac-card-content>
    <div class="made-in-the-us ac-flex-col ac-ctr ac-text-ctr ac-gap-lg">
      <ac-icon iconKey="hr:us_flag" [size]="60" />

      <div class="ac-flex-col ac-gap-md">
        <div class="ac-headline-sm">Homegrown and here for you</div>

        <div class="ac-label ac-body-md">
          We built Gains in the United States, for players in the United States.
          Our games, our support, and our operations are all run by American
          workers who care about delivering a trusted, world-class experience.
          From our first line of code to the moment you hit play, every step
          happens here at home. We invest in our players, and our country.
        </div>
      </div>
    </div>
  </ac-card-content>
</ac-card>
